(function($) {
    $(function() {
        var $buyTrigger = $('.retailer__links-trigger'),
            $buyButtons = $('.retailer__links'),
            $dropdown = $('.format-change');

        //Open the buy button dropdown
        $buyTrigger.on('click', function() {
            $buyButtons.toggleClass('open-buy-links');
        });

        $dropdown.on('change', function () {
            var url = $(this).val();
            if (url) {
                window.location = url;
            }
            return false;
        });

    });
})(jQuery);